<template>
  <listing-layout>
    <div slot="heading" class="d-flex justify-content-between align-items-center mb-3">
      <h1 class="h2 mb-0">Approved Expressions Of Interest</h1>
    </div>
    <div slot="content">

      <div class="alert alert-success" v-if="success">{{ success }}</div>
      <div class="alert alert-warning" v-if="error">{{ error }}</div>

      <data-table :dataRows="rows" :dataColumns="columns" :options="options">
        <tableTextTemplate slot-scope="{ row }" slot="expandedHeader" :text="row.user.first_name + ' ' + row.user.last_name" :link="'Member Profile'" :slug="row.user.user_id" :row="row" :options="{ showLinks: true }" />
        <div slot-scope="{ row }" slot="expandedRow">
          <ul class="list-unstyled mb-0 pt-2">
            <li>
              <strong>Phone Number: </strong>
              <tableTextTemplate :text="row.user.phone" :row="row" :mobile="row.phone" :options="{ isMobile: true, inline: true }" />
            </li>
            <li>
              <strong>Suburb: </strong>
              <tableTextTemplate :text="row.user.suburb" :row="row" :options="{ inline: true }" />
            </li>
            <li>
              <strong>Zone: </strong>
              <tableTextTemplate :text="$store.state.listZones.filter(zone => zone.id === row.user.zone_id).length > 0 ? $store.state.listZones.filter(zone => zone.id === row.user.zone_id)[0].code : 'Unspecified'" :row="row" :options="{ inline: true }" />
            </li>
            <li>
              <strong>Judge Status: </strong>
              <tableTextTemplate :text="row.user.status" :row="row" :options="{ inline: true }"/>
            </li>
            <li v-if="row.draft_application.status === 'cancelByJudge'">
              <strong>Expression Status: </strong>
              <span :class="['badge ml-1 my-auto alert-warning']">Cancelled</span>
            </li>
            <li>
              <DraftAndEvents :data="row" />
            </li>
          </ul>
        </div>
      </data-table>
    </div>
  </listing-layout>
</template>

<script>
import listingLayout from '@/components/ListingLayout'
import axios from 'axios'
import dataTable from '@/components/DataTable'
import tableTextTemplate from '@/components/DataTableFields/Text'
import DraftAndEvents from "./components/DraftAndEvents"

export default {

  name: "ApprovedExpressionInterest",
  components: {
    'listing-layout': listingLayout,
    'data-table': dataTable,
    DraftAndEvents,
    tableTextTemplate
  },
  data() {
    return {
      success: localStorage.getItem("judge-app-status"),
      error: '',
      rows: [],
      columns: [
        {
          label: 'First Name',
          headerClass: 'd-none d-lg-table-cell',
          visible: true,
          component: ({
            props: ['row'],
            components: { tableTextTemplate },
            template: `<tableTextTemplate :text="row.user.first_name" :slug="row.user.user_id" :link="'Member Profile'" :row="row" :options="{ showLinks: true }" />`
          }),
          representedAs(row) { return `${row.user.first_name}` }
        },
        {
          label: 'Last Name',
          headerClass: 'd-none d-lg-table-cell',
          visible: true,
          component: ({
            props: ['row'],
            components: { tableTextTemplate },
            template: `<tableTextTemplate :text="row.user.last_name" :slug="row.user.user_id" :link="'Member Profile'" :row="row" :options="{ showLinks: true }" />`
          }),
          representedAs(row) { return `${row.user.last_name}` }
        },
        {
          label: 'Draft and Events',
          field: 'draft_and_events',
          filterable: false,
          sortable: false,
          headerClass: 'd-none d-lg-table-cell',
          visible: true,
          component: ({
            props: ['row'],
            components: { DraftAndEvents },
            template: `<DraftAndEvents :data="row" />`
          }),
          representedAs: 'draft_and_events'
        },
        {
          label: 'Phone Number',
          field: 'contact',
          filterable: false,
          sortable: false,
          headerClass: 'd-none d-lg-table-cell',
          visible: true,
          component: ({
            props: ['row'],
            components: { tableTextTemplate },
            template: `<tableTextTemplate :text="row.user.phone" :row="row" :mobile="row.user.phone" :options="{ isMobile: true }" />`
          }),
          representedAs: 'phone'
        },
        {
          label: 'Suburb',
          field: 'suburb',
          filterable: false,
          sortable: false,
          headerClass: 'd-none d-lg-table-cell',
          visible: true,
          component: ({
            props: ['row'],
            components: { tableTextTemplate },
            template: `<tableTextTemplate :text="row.user.suburb" :row="row"/>`
          }),
          representedAs: 'suburb'
        },
        {
          label: 'Zone',
          field: 'zone_id',
          filterable: false,
          sortable: true,
          headerClass: 'd-none d-lg-table-cell',
          visible: true,
          component: ({
            props: ['row'],
            components: { tableTextTemplate },
            template: `<tableTextTemplate class="js-parity" :data-parity="row.parity" :text="rowZone(row.user.zone_id)" :row="row" />`,
            methods: {
              rowZone(theID) {
                return this.$store.state.listZones.filter(zone => zone.id === theID).length ? this.$store.state.listZones.find(zone => zone.id === theID).code : 'Unspecified'
              }
            }
          })
        },
        {
          label: 'Judge Status',
          field: 'status',
          filterable: false,
          headerClass: 'd-none d-lg-table-cell',
          visible: true,
          component: ({
            props: ['row'],
            components: { tableTextTemplate },
            template: `<tableTextTemplate :text="row.user.status" :row="row"/>`
          }),
          representedAs: 'status'
        },
        {
          label: 'Expression Status',
          field: 'status',
          filterable: false,
          headerClass: 'd-none d-lg-table-cell',
          visible: true,
          component: ({
            props: ['row'],
            template: `<span :class="['badge ml-1 my-auto alert-warning', row.draft_application.status !== 'cancelByJudge' ? 'd-none' : '']">Cancelled</span>`
          }),
          representedAs: 'status'
        }
      ],
      options: {
        filter: {},
        activeFilter: {},
        search: false,
        loaded: false
      }
    }
  },
  computed: {
    listZones() {
      return this.$store.state.listZones
    }
  },
  watch: {
    listZones() {
      if (this.listZones.length > 0) {
        this.rows.map((item) => {
          const tempItem = item
          tempItem.zone_name = this.listZones.filter(zone => zone.id === tempItem.zone_id).length > 0 ? this.listZones.filter(zone => zone.id === tempItem.zone_id)[0].code : 'Unspecified'
          return tempItem
        })
      }
    }
  },
  mounted() {
    axios.get(`${this.$api}/judges/draft-applications/approved-applications`).then((response) => {
      if (response.data.status === 'success') {
        this.error = ''
        const rows = response.data.data
        if (this.listZones.length > 0) {
          rows.map((item) => {
            const tempItem = item
            tempItem.zone_name = this.listZones.filter(zone => zone.id === tempItem.zone_id).length > 0 ? this.listZones.filter(zone => zone.id === tempItem.zone_id)[0].code : 'Unspecified'
            return tempItem
          })
        }
        this.rows = rows
        this.options.loaded = true
      } else {
        this.error = 'Unable to receive data from the server. Please reload the page.'
      }
    })
    localStorage.removeItem("judge-app-status")
  },
  methods: {

  }
}
</script>

<style>
@media screen and (max-width: 1300px) {

  .btn-actions {
    max-width: 250px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Judges/Secretary/ApprovedExpressionInterest.vue